var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0397 21H24V18.1671H18.6429C20.9444 16.3533 23.7817 13.7446 23.7817 10.4837C23.7817 7.9769 22.3135 6 19.0198 6C16.381 6 14.0992 7.54891 14 11.1562H17.2738C17.2738 9.75 17.869 8.93478 18.881 8.93478C19.9127 8.93478 20.3889 9.62772 20.3889 10.7079C20.3889 13.2147 17.1151 15.803 14.0397 18.4117V21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38109 12.5351C5.90441 8.69617 4.42771 4.85716 3 1H7.94205L11.7668 11.6149L15.4002 1H20L18.5577 5.01411C17.2093 5.09714 15.9024 5.55102 14.8812 6.48882C13.732 7.54414 13.0559 9.10994 13.0004 11.1288L12.9722 12.1562H15.9916L14.2908 16.8899C14.1956 16.9704 14.1 17.0511 14.0042 17.1321L14.0042 17.1321L14.0037 17.1325C13.8012 17.3035 13.5974 17.4756 13.3929 17.6491L13.0397 17.9486V20.3719L11.7362 24C10.3166 20.1666 8.84883 16.3509 7.38109 12.5351Z",
    fill: "url(#paint0_linear_4785_37823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4785_37823",
    x1: 11.4998,
    y1: -13.0141,
    x2: 11.4998,
    y2: 26.7373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203123,
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.c3beb3704c02803e0f4624b7e6c1f9d6.svg";
export { ForwardRef as ReactComponent };